import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import { geMicrobundleServiceInfo } from 'utils/api/queries/omantelMicroApi';
import { AjaxResponse } from 'rxjs/ajax';

export class MicroBundleServiceInfo extends GenericService {
	// get service status and service information about microbundle additional benefits
	public static getMicroBundleServiceInfo(data: any): Observable<AjaxResponse> {
		const payload = {
			...data
		};
		return geMicrobundleServiceInfo(payload)
			.withErrorHandling()
			//it will allow consecutive calls to happen when the content changes so that the browser doesn't caches the request headers
			.setAllowConsecutiveCalls()
			.disableCache()
			.call();
	}
}
